import React, { useState } from "react";

export default function Citation() {
  const citations = {
    APA: (
      <>
        Wemmer-Rogh, W., Gossner, L., Kamer, O. & Praetorius, A.-K. (2023).{" "}
        <i>
          FormATool - Eine digitale Lösung für die Weiterentwicklung von
          kognitiver Aktivierung im Unterricht.
        </i>{" "}
        Abrufbar unter: formatool.ife.uzh.ch. Universität Zürich.
      </>
    ),
    BIBTeX: (
      <>
        <pre>
          {`misc{
  Wemmer-Rogh_Gossner_Kamer_Praetorius_2023,
  title={FormATool - Eine digitale Lösung für die Weiterentwicklung von kognitiver Aktivierung im Unterricht}},
  url={formatool.ife.uzh.ch},
  publisher={Universität Zürich},
  author={Wemmer-Rogh, Wida and Gossner, Leonie and Kamer, Oliver and Praetorius, Anna-Katharina},
  year={2023}
}`}
        </pre>
      </>
    ),
    MLA: (
      <>
        Wemmer-Rogh, Wida, et al.{" "}
        <i>
          FormATool - Eine Digitale Lösung Für Die Weiterentwicklung von
          Kognitiver Aktivierung Im Unterricht.
        </i>
        s Universität Zürich, 2023, formatool.ife.uzh.ch.
      </>
    ),
    IEEE: (
      <>
        W. Wemmer-Rogh, L. Gossner, O. Kamer, and A.-K. Praetorius, “FormATool -
        Eine digitale Lösung für die Weiterentwicklung von kognitiver
        Aktivierung im Unterricht.” Universität Zürich, 2023. [Online].
        Available: formatool.ife.uzh.ch
      </>
    ),
  };

  const availableCitations = Object.keys(citations);

  const [selectedCitation, setSelectedCitation] = useState(
    availableCitations[0]
  );

  return (
    <>
      <br />
      {citations[selectedCitation]} <br />
      {availableCitations.map((el) => (
        <span>
          <button
            style={{
              textDecoration: selectedCitation === el ? "underline" : "none",
            }}
            onClick={() => setSelectedCitation(el)}
          >
            {el}
          </button>{" "}
        </span>
      ))}
    </>
  );
}
